import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const HolidaySearchParamsSchema = z
  .object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
  })
  .merge(BasePaginateParamsSchema)

export type HolidaySearchParams = z.infer<typeof HolidaySearchParamsSchema>

export const HolidaySearchResultModelSchema = z.object({
  id: z.number(),
  date: z.coerce.date(),
  description: z.string(),
})

export type HolidaySearchResultModel = z.infer<
  typeof HolidaySearchResultModelSchema
>

export const HolidaySearchResultSchema = z
  .object({
    data: z.array(HolidaySearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type HolidaySearchResult = z.infer<typeof HolidaySearchResultSchema>
